export default __webpack_public_path__ + "2eb1a197817089dd8390a87c5acd7aaf.png";